"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpansionTrigger = void 0;
const getExpansionTrigger = ({
  isItemEditable,
  expansionTrigger
}) => {
  if (expansionTrigger) {
    return expansionTrigger;
  }
  if (isItemEditable) {
    return 'iconContainer';
  }
  return 'content';
};
exports.getExpansionTrigger = getExpansionTrigger;